import type { OtherProject } from "../types/project";

export const otherProjects: OtherProject[] = [
  {
    slug: "focus-booster",
    title: "Focus-Booster",
    description: "A Chrome extension for staying on task during work sessions.",
    tags: ["javascript"],
    url: "https://chromewebstore.google.com/detail/plnffembcfidgbmkfhoajmifkdbbnahd?utm_source=item-share-cb",
  },
];
